/**
 * @module app.checkboxDirective
 */
import appBase from './index.js';

/**
 * @return {angular.Directive} The directive specs.
 * @ngInject
 */
const directive = function() {
  return {
    restrict: 'A',
    link:
        /**
         * @param {angular.Scope} $scope Scope.
         * @param {jQuery} element Element.
         * @param {angular.Attributes} attrs Attributes.
         */
        function($scope, element, attrs) {
          const parent = element;
          const container = $(attrs['appCheckbox']);
          const children = container.find('[type=checkbox]');
          const model = attrs['ngModel'];
          console.assert(model);

          const setChildrenChecked = function(checked) {
            children.filter(checked ? ':not(:checked)' : ':checked').click();
          };

          // Needed to propagate check status when parent status is set by
          // the controller.
          $scope.$watch(model, function(value) {
            setChildrenChecked(value !== undefined ? value : false);
          }, true);

          element.on('change', function(event) {
            setChildrenChecked($(event.target).prop('checked'));
          });

          children.on('change', function(event) {
            const count = children.filter(':checked').length;
            if (count === 0) {
              parent.prop('indeterminate', false);
              parent.prop('checked', false);
            } else if (count == children.filter(':not(:disabled)').length) {
              parent.prop('indeterminate', false);
              parent.prop('checked', true);
            } else {
              parent.prop('indeterminate', true);
            }
            // force digest to trigger indeterminate watch on parent
            if (!$scope.$$phase) {
              $scope.$digest();
            }
          });
        }
  };
};

appBase.directive('appCheckbox', directive);


export default directive;
